import { useAppSelector } from '@/shared/lib/redux';

/**
 * Вывод текущий роли - актер(соискатель) или режисер(работодатель)
 */
export const useRole = () => {
  const role = useAppSelector(state => state.user?.data?.activity.id);

  return role;
};
